export default __webpack_public_path__ + "static/media/roboto-v20-latin-100italic.e8e8941e.eot";